var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96751 10.5599C3.32097 10.5599 3.60751 10.8465 3.60751 11.1999V12.4799C3.60751 12.6497 3.67493 12.8124 3.79498 12.9325C3.91499 13.0525 4.07777 13.1199 4.24751 13.1199H11.9275C12.0972 13.1199 12.26 13.0525 12.38 12.9325C12.5001 12.8124 12.5675 12.6497 12.5675 12.4799V11.1999C12.5675 10.8465 12.854 10.5599 13.2075 10.5599C13.561 10.5599 13.8475 10.8465 13.8475 11.1999V12.4799C13.8475 12.9891 13.6453 13.4775 13.2851 13.8376C12.9251 14.1976 12.4367 14.3999 11.9275 14.3999H4.24751C3.73831 14.3999 3.24993 14.1977 2.88986 13.8376C2.52981 13.4775 2.32751 12.9891 2.32751 12.4799V11.1999C2.32751 10.8465 2.61405 10.5599 2.96751 10.5599Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43495 6.90743C4.68489 6.65749 5.09011 6.65749 5.34005 6.90743L8.08748 9.65488L10.8349 6.90743C11.0849 6.65749 11.4901 6.65749 11.74 6.90743C11.99 7.15735 11.99 7.56259 11.74 7.81251L8.54003 11.0125C8.29011 11.2624 7.88486 11.2624 7.63494 11.0125L4.43495 7.81251C4.18501 7.56259 4.18501 7.15735 4.43495 6.90743Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08751 2.23999C8.44098 2.23999 8.72751 2.52653 8.72751 2.87999V10.56C8.72751 10.9135 8.44098 11.2 8.08751 11.2C7.73404 11.2 7.44751 10.9135 7.44751 10.56V2.87999C7.44751 2.52653 7.73404 2.23999 8.08751 2.23999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.df031f08d1d0ca23d68f027a1d65e191.svg";
export { ForwardRef as ReactComponent };